import { BaseResource } from "./base.resource";

export const ContainerTypeAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class ContainerType extends BaseResource {
  active: boolean;
  code: string;
  description: string;
  material: string;
  size?: number;
  unit: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & ContainerTypeAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & ContainerTypeAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & ContainerTypeAccessLevel.Delete) > 0;
  }
}
